import { TabProps } from '../interfaces';
import { PersonalDetailsTab } from './PersonalDetailsTab';
import { ContactDetailsTab } from './ContactDetailsTab';
import { StatusTab } from './StatusTab';
import { TabContent } from './TabContent';

export const BrokerDetailsTab: React.FC<TabProps> = ({ form, mode, selectsOptions }) => {
  return (
    <TabContent>
      <PersonalDetailsTab form={form} mode={mode} selectsOptions={selectsOptions} />
      <ContactDetailsTab form={form} mode={mode} selectsOptions={selectsOptions} />
      <StatusTab form={form} mode={mode} selectsOptions={selectsOptions} />
    </TabContent>
  );
};
